import { Slider } from '@/components/ui/slider';

export const SliderInput = ({
  label,
  description,
  value,
  onChange,
  min,
  max,
  step,
  displayValue,
  minLabel,
  maxLabel,
  testIdPrefix,
  titleSize = 'text-base font-medium',
  valueSize = 'text-xl font-bold text-slate-900',
  valueStyle = {},
  className = 'mb-10',
  disabled = false,
}) => {
  const handleChange = (val) => onChange(val[0]);
  const wrapperClass = disabled ? `${className} opacity-50` : className;

  return (
    <div className={wrapperClass}>
      <div className="flex justify-between items-baseline mb-3">
        <label className={`${titleSize} text-slate-900`}>{label}</label>
        <span className={valueSize} style={valueStyle} data-testid={`${testIdPrefix}-value`}>
          {displayValue}
        </span>
      </div>
      {description && (
        <p className="text-sm text-slate-500 mb-3 italic">{description}</p>
      )}
      <Slider
        data-testid={`${testIdPrefix}-slider`}
        value={[value]}
        onValueChange={handleChange}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        className="slider-custom"
      />
      <div className="flex justify-between text-xs text-slate-500 mt-2">
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>
    </div>
  );
};
